﻿/**
* DevExpress Analytics (query-builder\wizard\dataSourceWizardState.js)
* Version:  21.2.7
* Build date: Apr 13, 2022
* Copyright (c) 2012 - 2022 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var chooseDataSourceTypePage_1 = require("./pages/chooseDataSourceTypePage");
var configureQueryPage_1 = require("./pages/sqlDataSourceWizard/configureQueryPage");
var serializer_1 = require("../../serializer/serializer");
var masterDetailRelation_1 = require("../dataSource/sql/masterDetailRelation");
var _utils_1 = require("../../undo-engine/_utils");
var jsonDataSource_1 = require("../dataSource/json/jsonDataSource");
var objectDataSource_1 = require("../dataSource/object/objectDataSource");
var _defaultRestoreSqlDataSourceFromState = function (state, requestWrapper, dataSourceId) {
    var _a, _b;
    var wrapper = new configureQueryPage_1._SqlDataSourceWrapper(state.sqlDataSourceJSON, state.queryName, requestWrapper);
    state.name && wrapper.sqlDataSource.connection.name(state.name);
    var serializer = new serializer_1.ModelSerializer();
    if (state.customQueries && state.customQueries.length > 0) {
        wrapper.customQueries = state.customQueries.map(function (query) {
            return wrapper.sqlDataSource.createQuery(JSON.parse(query), serializer);
        });
        (_a = wrapper.sqlDataSource.queries).push.apply(_a, wrapper.customQueries);
    }
    if (state.relations && state.relations.length > 0) {
        (_b = wrapper.sqlDataSource.relations).push.apply(_b, state.relations.map(function (relation) {
            return new masterDetailRelation_1.MasterDetailRelation(JSON.parse(relation), serializer);
        }));
    }
    wrapper.sqlDataSource.id = dataSourceId || _utils_1.guid().replace(/-/g, '');
    return wrapper;
};
exports._restoreSqlDataSourceFromState = _defaultRestoreSqlDataSourceFromState;
exports._setRestoreSqlDataSourceFromState = function (func) { return exports._restoreSqlDataSourceFromState = func; };
exports._resetRestoreSqlDataSourceFromState = function () { return exports._restoreSqlDataSourceFromState = _defaultRestoreSqlDataSourceFromState; };
var _defaultRestoreJsonDataSourceFromState = function (state, requestWrapper, dataSourceId) {
    var jsonDataSource = new jsonDataSource_1.JsonDataSource({
        'Source': state.jsonSource && JSON.parse(state.jsonSource) || {},
        'Schema': state.jsonScheme && JSON.parse(state.jsonScheme) || {},
        '@RootElement': state.rootElement || ''
    }, undefined, requestWrapper);
    state.connectionName && jsonDataSource.connectionName(state.connectionName);
    state.dataSourceName && jsonDataSource.name(state.dataSourceName);
    jsonDataSource.id = dataSourceId || _utils_1.guid().replace(/-/g, '');
    return jsonDataSource;
};
exports._restoreJsonDataSourceFromState = _defaultRestoreJsonDataSourceFromState;
function _setRestoreJsonDataSourceFromState(func) { exports._restoreJsonDataSourceFromState = func; }
exports._setRestoreJsonDataSourceFromState = _setRestoreJsonDataSourceFromState;
function _resetRestoreJsonDataSourceFromState() { exports._restoreJsonDataSourceFromState = _defaultRestoreJsonDataSourceFromState; }
exports._resetRestoreJsonDataSourceFromState = _resetRestoreJsonDataSourceFromState;
function _restoreObjectDataSourceFromState(state, requestWrapper, dataSourceId) {
    var objectDataSource = new objectDataSource_1.ObjectDataSource();
    objectDataSource.setState(state);
    if (dataSourceId)
        objectDataSource.id = dataSourceId;
    return objectDataSource;
}
exports._restoreObjectDataSourceFromState = _restoreObjectDataSourceFromState;
function _createDefaultDataSourceWizardState(sqlDataSourceWizardState, jsonDataSourceWizardState, objectDataSourceWizardState) {
    if (sqlDataSourceWizardState === void 0) { sqlDataSourceWizardState = {}; }
    if (jsonDataSourceWizardState === void 0) { jsonDataSourceWizardState = { jsonSource: '' }; }
    if (objectDataSourceWizardState === void 0) { objectDataSourceWizardState = {}; }
    return {
        dataSourceType: chooseDataSourceTypePage_1.DataSourceType.Sql,
        jsonDataSourceWizard: jsonDataSourceWizardState,
        sqlDataSourceWizard: sqlDataSourceWizardState,
        objectDataSourceWizard: objectDataSourceWizardState,
        dataSourceId: _utils_1.guid().replace(/-/g, '')
    };
}
exports._createDefaultDataSourceWizardState = _createDefaultDataSourceWizardState;
